<div class="overflow-y-auto" *ngIf="hasPins$ | async; else noPins">
	<app-teranet-pin-view class="block"></app-teranet-pin-view>

	<form #syncForm="ngForm" *ngIf="primary">
		<div class="px-8 py-4 overflow-y-auto relative">
			<app-teranet-sync-inner-form
				(onSyncSuccess)="onSyncSuccess($event)"
				[form]="syncForm"
				(onError)="setError($event)"
				[submit$]="submitSubject.asObservable()"
			></app-teranet-sync-inner-form>

			<div
				*ngIf="error != null"
				class="fixed bottom-28 right-10 border rounded-md bg-white px-3 py-2"
			>
				<app-icon [icon]="ICON.EXCLAMATION" class="mr-2"></app-icon>
				{{ error }}
			</div>
		</div>
	</form>
</div>

<ng-template #noPins>
	<app-teranet-no-pin></app-teranet-no-pin>
</ng-template>

<ui-content-footer
	[primaryAction]="{ text: 'Continue', action: onSubmit }"
	[secondaryAction]="{ text: 'Back', action: back }"
></ui-content-footer>
